
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb';
import { BreadcrumbStructuredData } from '@/components/structured-data/BreadcrumbStructuredData';
import { ShortContentItem } from '@/hooks/useShortContent';

interface TravelByteBreadcrumbsProps {
  item?: ShortContentItem;
  baseUrl: string;
}

export function TravelByteBreadcrumbs({ item, baseUrl }: TravelByteBreadcrumbsProps) {
  const breadcrumbItems = [
    { name: 'Home', url: '/', position: 1 },
    { name: 'Travel Bytes', url: '/travel-bytes', position: 2 }
  ];

  if (item) {
    breadcrumbItems.push({
      name: item.title,
      url: `/travel-bytes/${item.slug}`,
      position: 3
    });
  }

  return (
    <>
      <BreadcrumbStructuredData items={breadcrumbItems} baseUrl={baseUrl} />
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/travel-bytes">Travel Bytes</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {item && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{item.title}</BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </>
  );
}
